import moment from "moment-timezone";

export class ExamScheduleModel {
    constructor(record) {
        this.id = record.id;
        this.timeExam = this.formatTime(record.start_time, record.end_time);
        this.dateExam = this.formatDate(record.exam_date);
        this.center = record?.center?.name ?? '';
        this.testForm = this.testFormString(record.exam_form);
        this.type = this.typeExamString(record.exam_type);
        this.data = {...record};
        this.action = record.action
        this.adminName = record.adminName
    }
    formatDate(value) {
        if (value) {
            return moment(value).format('DD-MM-YYYY');
        }
        return ''
    }
    formatTime(start, end) {
        if (start && end) {
            return `${start} - ${end}`;
        }
        return ''
    }
    testFormString(value) {
        switch (value) {
            case 1:
                return 'Online'
            case 2:
                return 'Offline'
            default:
                return ''
        }
    }
    typeExamString(value) {
        switch (value) {
            case 0:
                return 'Thi chính'
            case 1:
                return 'Thi thử'
            case 2:
                return 'Thi đầu khóa'
            case 3:
                return 'Thi lại'
            default:
                return ''
        }
    }
}
